import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { SnackbarComponent } from '@atoms/snackbar/snackbar.component';
import { hasAnyRole, isExternalUser, RolesEnum } from '@definitions/role.interface';
import { AuthService } from '@services/auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const snackbarService = inject(MatSnackBar);

  const allowedRoles = route.data['allowedRoles'] as RolesEnum[] | undefined;
  const roles = authService.user()?.roles ?? [];

  if (allowedRoles && hasAnyRole(roles, allowedRoles)) {
    return true;
  }

  if (roles.length === 0) {
    snackbarService.openFromComponent(SnackbarComponent, {
      data: {
        type: 'error',
        messageHTML: 'Tu usuario no tiene ningún rol asignado. Contacta con soporte.'
      },
      duration: 5000
    });
    authService.logout();

    return false;
  }

  return router.createUrlTree([isExternalUser(roles) ? '/communications' : '/overview']);
};
